// extracted by mini-css-extract-plugin
export default {"container":"FullScreenSpinner_container__u0CtC"};